import {
  TYRO_RESET_MODAL,
  TYRO_SET_MODAL_STATUS 
} from '../constants';


const INIT_STATE = {
  isModalActive: false
}


export default function(state = INIT_STATE, action) {
  switch (action.type) {
    case TYRO_RESET_MODAL: {
      return INIT_STATE;
    }
    
    case TYRO_SET_MODAL_STATUS: {
      return {
        ...state,
        isModalActive: action.payload
      }
    }
  
    default: {
      return state;
    }
  }
}